import { withDependencies } from '@wix/thunderbolt-ioc'
import {
	DSViewModeAPISymbol,
	IAppWillMountHandler,
	IPageWillMountHandler,
	IPropsStore,
	IStructureAPI,
	IViewMode,
	Props,
	StructureAPI,
	isViewerFragmentSymbol,
} from '@wix/thunderbolt-symbols'

export const mobileClassUpdater = withDependencies<IPageWillMountHandler & IAppWillMountHandler>(
	[DSViewModeAPISymbol, Props, StructureAPI, isViewerFragmentSymbol],
	(viewMode: IViewMode, props: IPropsStore, structureApi: IStructureAPI, isViewerFragment: boolean) => {
		if (isViewerFragment) {
			return {
				name: 'mobileClassUpdater',
				pageWillMount: () => {},
				appWillMount: () => {},
			}
		}

		return {
			name: 'mobileClassUpdater',
			pageWillMount: () => {
				props.update({
					bodyClassUpdater: {
						isMobile: viewMode.getWantedIsMobileView(),
					},
				})
			},
			appWillMount: () => {
				structureApi.addComponentToDynamicStructure('bodyClassUpdater', {
					components: [],
					componentType: 'BodyClassUpdater',
				})
			},
		}
	}
)
